export default __webpack_public_path__ + "./images/ax.ee934938.png";